// @ts-check
import { useState } from 'react';
import { StyledSettingsModal } from './SettingsModal.style';
import Icon from 'components/base/Icon';
import useFormCostSetting from './useFormCostSetting';
import CostSetting from './CostSetting/CostSetting';
import useFormInputsSetting from './useFormInputsSetting';
import InputsSetting from './InputsSetting/InputsSetting';
import useToast from 'components/hooks/useToast';
import useRaCostSetting from '../hooks/useRaCostSetting';
import useRaInputsSetting from '../hooks/useRaInputsSetting';
import useRaWidgetsConfig from '../hooks/useRaWidgetsConfig';
import useFormWidgetsConfig from './useFormWidgetsConfig';
import DonutConfig from './DonutConfig/DonutConfig';
import OverTimeChartConfig from './OverTimeChartConfig/OverTimeChartConfig';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';

const SettingsModal = () => {
  const costSetting = useRaCostSetting();
  const inputsSetting = useRaInputsSetting();
  const widgetsConfig = useRaWidgetsConfig();

  const toast = useToast();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const formCostSetting = useFormCostSetting(costSetting);
  const formInputsSetting = useFormInputsSetting(inputsSetting);
  const formWidgetsConfig = useFormWidgetsConfig(widgetsConfig.value);

  const onClose = () =>
    history.replace(AppRouter.PROJECTS_RESOURCE_ALLOCATION_OVERVIEW.path);

  const onSave = async () => {
    try {
      setIsLoading(true);

      await costSetting.onSave({
        isEnabled: formCostSetting.isEnabled,
        currency: formCostSetting.currency,
        value: formCostSetting.value
      });
      await inputsSetting.onSave({
        excluded_types: formInputsSetting.excludedTypes,
        additional_types: formInputsSetting.additionalTypes
      });
      await widgetsConfig.onSave(formWidgetsConfig.widgetsConfig);

      toast({
        variant: 'success',
        message: `Report settings saved successfully`
      });
    } catch (e) {
      toast({
        variant: 'error',
        message: `Ooops. Report settings could not be saved. please try again`
      });
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <StyledSettingsModal>
      <header>
        <Icon name='PeopleClock' size='normal' />
        Resource Allocation Report Settings
        <div className='ml-auto'>
          <LBButton onClick={onClose} variant='ghost' size='icon'>
            <Icon name='close' size='small' />
          </LBButton>
        </div>
      </header>
      <main>
        <InputsSetting formInputsSetting={formInputsSetting} />
        <DonutConfig formWidgetsConfig={formWidgetsConfig} />
        <OverTimeChartConfig formWidgetsConfig={formWidgetsConfig} />
        <CostSetting formCostSetting={formCostSetting} />
      </main>
      <footer>
        <LBButton size='lg' onClick={onSave} disabled={isLoading}>
          {isLoading ? 'Loading...' : 'Save'}
        </LBButton>
      </footer>
    </StyledSettingsModal>
  );
};

export default SettingsModal;
